module.exports = __webpack_public_path__ + "static/img/QB100.91b9d8a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/QB100.png
// module id = 95JB
// module chunks = 2